let debounceTimer = null;
export function debounce(callback, duration, isFirstExecution) {
  return (function (...args) {
    let ctx = this;
    const delay = function () {
      debounceTimer = null;
      if (!isFirstExecution) callback.apply(ctx, args);
    };
    let executeNow = isFirstExecution && !debounceTimer;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(delay, duration);
    if (executeNow) callback.apply(ctx, args);
  })();
};